var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('client-only', [_c('Teleport', {
    attrs: {
      "to": "body"
    }
  }, [_c('Transition', {
    attrs: {
      "name": "modal"
    }
  }, [_vm.open ? _c('div', {
    staticClass: "modal",
    class: {
      'bg-blur': _vm.blur
    },
    style: {
      'z-index': _vm.zIndex
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_vm._t("default")], 2)]) : _vm._e()])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };